import { render, staticRenderFns } from "./DatasetPopup.vue?vue&type=template&id=e79b9360&scoped=true&"
import script from "./DatasetPopup.vue?vue&type=script&lang=js&"
export * from "./DatasetPopup.vue?vue&type=script&lang=js&"
import style0 from "./DatasetPopup.vue?vue&type=style&index=0&id=e79b9360&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79b9360",
  null
  
)

export default component.exports